module.exports = __webpack_public_path__ + "static/image2-98ca8921be2876ffe5f5058fcab39ac3.jpg";